// extracted by mini-css-extract-plugin
export var notificationHost = "_jt-0";